import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import ReactModal from 'react-modal';
import { Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { _getOrdCondStr, _convertActTypeToStr } from '../../../utils';

const customStyles = {
  content: {
    top: '80px',
    left: '50%',
    width: '500px',
    transform: 'translate(-50%)',
    bottom: 'auto',
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: '3',
  },
};

class FormDeleteOrdCond extends Component {
  submit = (values) => {
    const { order } = this.props;

    this.props.handleSubmitOrder(order);
    // this.props.reset();
  };

  render() {
    const {
      handleSubmit,
      submitting,
      showModal,
      handleCloseModal,
      order,
    } = this.props;

    // console.log(order)

    return (
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
      >
        <Card>
          <Card.Header>
            <span>Xác nhận huỷ lệnh</span>
            <FaTimes
              onClick={handleCloseModal}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            />
          </Card.Header>
          <Card.Body>
            <form className="form-trade" onSubmit={handleSubmit(this.submit)}>
              <table className="table table-no-bordered">
                <tbody>
                  <tr>
                    <td className="fz-14 content-read">Mã chứng khoán</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.symbol}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Loại lệnh</td>
                    <td
                      className={
                        'fz-18 content-read font-weight-bold ' +
                        (order && (order.side === 'B' ? 'i' : 'd'))
                      }
                    >
                      {order && (order.side === 'B' ? 'MUA' : 'BÁN')}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Loại điều kiện</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && _getOrdCondStr(order.ordertype)}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Điều kiện đặt</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && _convertActTypeToStr(order.activetype)}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Ngày đặt</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.createddt}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Ngày hết hạn</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.expireddt}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Số hiệu lệnh</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.ordrNo}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="d-flex justify-content-center mt-2">
                <button
                  type="submit"
                  disabled={submitting}
                  className="btn font-weight-bold fz-14 ml-2 btn-order order-buy"
                >
                  {`Chấp nhận`}
                </button>
                <button
                  type="button"
                  disabled={submitting}
                  onClick={handleCloseModal}
                  className="btn font-weight-bold fz-14 btn-order ml-2"
                >
                  {`Huỷ`}
                </button>
              </div>
            </form>
          </Card.Body>
        </Card>
      </ReactModal>
    );
  }
}

FormDeleteOrdCond = reduxForm({
  form: 'deleteOrdCond',
})(FormDeleteOrdCond);

FormDeleteOrdCond = connect()(FormDeleteOrdCond);

export default FormDeleteOrdCond;
